import { render, staticRenderFns } from "./NewUpdateDialog.vue?vue&type=template&id=36ce8df6&scoped=true&"
import script from "./NewUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./NewUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce8df6",
  null
  
)

export default component.exports